import { Routes } from '@angular/router';
import { DocumentStateService } from './document-state.service';

export const documentRoutes: Routes = [
  {
    path: '',
    providers: [DocumentStateService],
    loadComponent: () => import('./document-container/document-container.component').then((x) => x.DocumentContainerComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./document-dashboard/document-dashboard.component').then((x) => x.DocumentDashboardComponent),
      },
      {
        path: 'grid',
        loadComponent: () => import('./document-grid/document-grid.component').then((x) => x.DocumentGridComponent),
      },
      {
        path: 'grid/:categoryUuid',
        loadComponent: () => import('./document-grid/document-grid.component').then((x) => x.DocumentGridComponent),
      },
    ],
  },
];
